<template>
    <v-responsive>
        <v-card tile elevation="0">
            <v-data-table :items="boards" :headers="headers" disable-pagination disable-sort hide-default-footer :items-per-page="-1">
                <span slot="item.no" slot-scope="{item}">
                    <v-icon v-if="item.isNotice" color="yellow darken-2">mdi-alert-circle-outline</v-icon>
                    <span v-else>{{ (page - 1) * limit + +boards.filter(noti => !noti.isNotice).indexOf(item) + 1 }}</span>
                </span>
                <v-btn text tile slot="item.subject" slot-scope="{item}" :to="`/board/event/${item._id}`">{{ item.subject }}</v-btn>
                <span slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
            </v-data-table>
        </v-card>
        <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-4" @input="search(true)"/>
    </v-responsive>
</template>

<script>
import api from "@/api";
export default {
    props: {
        boards: { type: Array, default(){ return [] } },
        summary: { type: Object }
    },
    data(){
        return {
            page: this.$attrs.page || 1,
            pageCount: Math.ceil((this.$props?.summary?.totalCount || 0) / this.$attrs.limit) || 0,
            skip: this.$attrs.skip || 0,
            limit: this.$attrs.limit || 10,

            headers: [
                { text: "no", value: "no", align: "center", width: 100 },
                { text: "제목", value: "subject", align: "center" },
                { text: "작성일자", value: "createdAt", align: "center", width: 180 },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.router.push({
                    query: { ...this.filter, page: this.page }
                })
            }

            let { boards: statics } = await api.v1.center.boards.gets({
                headers: { limit: 0 },
                params: { isNotice: true }
            });

            let { summary, boards} = await api.v1.center.boards.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });


            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.boards = [ ...statics, ...boards ];
        },

    },
}
</script>